import { PRAVDA_USER_POLICY_ENABLED } from 'reactApp/appHelpers/featuresHelpers/features/pravdaUserPolicy';
import { getClosestDomainBitmask } from 'reactApp/modules/domainFolders/domainFolders.selectors';
import {
    getAccessDeniedMask,
    getDomainFoldersBitmaskParams,
    getFullAccessMask,
    hasAccessDenied,
} from 'server/helpers/getDomainFolderBitmaskParams';

export const getDomainRestrictionsForBitmask = (bitmask) => {
    const { READ_FLAG, DOWNLOAD_FLAG, EDIT_FLAG, CREATE_FLAG, SHARE_FLAG, DELETE_FLAG, ACCESS_DENIED_FLAG } =
        getDomainFoldersBitmaskParams(bitmask);

    return {
        isDomainAndReadRestricted: !READ_FLAG,
        isDomainAndDownloadRestricted: !DOWNLOAD_FLAG,
        isDomainAndEditRestricted: !EDIT_FLAG,
        isDomainAndCreateRestricted: !CREATE_FLAG,
        isDomainAndShareRestricted: !SHARE_FLAG,
        isDomainAndDeleteRestricted: !DELETE_FLAG,
        isDomainAndAccessDenied: ACCESS_DENIED_FLAG,
    };
};

export const getDomainRestrictionsForItems = (items, reduxState) => {
    const initialMask = -1;
    if (!PRAVDA_USER_POLICY_ENABLED) {
        return getDomainRestrictionsForBitmask(getFullAccessMask());
    }

    if (!Array.isArray(items)) {
        items = [items];
    }

    const bitmask = items.reduce((result, item) => {
        const id = typeof item === 'string' ? item : item?.id;

        let bitmask = getClosestDomainBitmask(reduxState, id);
        if (typeof bitmask === 'number') {
            // Если в маске установлен флаг access denied, то отменяем все остальные права
            if (hasAccessDenied(bitmask)) {
                bitmask = getAccessDeniedMask();
            }

            result = result & bitmask;
        }

        return result;
    }, initialMask);

    if (bitmask === initialMask) {
        return getDomainRestrictionsForBitmask(getFullAccessMask());
    }

    return getDomainRestrictionsForBitmask(bitmask);
};
